module.exports = "/_next/static/images/Personalization-xs@2x-ad66699cb9e13cda0c1cc0c5ec30e605.png";